function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "var(--primary-color, #000)"
}, /*#__PURE__*/React.createElement("g", {
  strokeLinecap: "square",
  strokeWidth: 1.002
}, /*#__PURE__*/React.createElement("path", {
  d: "M29.517 6.923a6.304 6.304 0 00-7.213 2.811 3.94 3.94 0 00-5.265 5.651 3.94 3.94 0 001.088 7.65 5.32 5.32 0 009.617 2.631c.643.549 1.39.963 2.195 1.218a6.304 6.304 0 008.19-5.727 3.94 3.94 0 002.472-7.367 3.94 3.94 0 00-2.726-4.234 3.94 3.94 0 00-4.232 1.265 6.304 6.304 0 00-4.126-3.897z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M40.901 12.404c1.996.317 4.25 1.467 4.573 3.462a5.546 5.546 0 016.404 7.63 3.466 3.466 0 01-.949 6.77 3.466 3.466 0 01-3.81 2.263 3.466 3.466 0 01-2.834-2.659 5.546 5.546 0 01-4.78 1.447h0c-2.5-.437-3.96-2.517-4.15-5.047M17.038 15.385c-1.275-1.168-3.567-2.506-5.269-2.202l-.082.015h0a5.546 5.546 0 00-4.479 5.132 3.462 3.462 0 00-3.653 4.066 3.466 3.466 0 001.852 2.486 3.466 3.466 0 003.967 5.52 4.681 4.681 0 008.571-1.868 5.546 5.546 0 002.208.054 5.803 5.803 0 001.527-.942"
})), /*#__PURE__*/React.createElement("path", {
  d: "M15.944 31.815c5.54 6.509 7.265 14.239 8.32 22.185h9.705c.57-8.9 5.107-16.248 9.706-23.571"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.717 29.042l8.45 14.188c0-8.616-.13-14.188-.13-16.961M31.474 27.076c0 4.16.138 11.977 1.077 15.078l6.955-10.837M25.955 14.201c3.388-1.898 7.224.062 7.673 3.919M44.8 20.802c4.8-.39 5.19 4.411 3.906 6.448M12.088 19.537c-2.457-1.376-5.239.045-5.564 2.842"
}));

var SvgBroccoli = function SvgBroccoli(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBroccoli, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Broccoli.d1c01935.svg";
export { ForwardRef as ReactComponent };